export const IMPORTANCE_LABELS = {
  1: "Very important",
  2: "Important",
  3: "Not so important",
};

const TONES = {
  1: "bg-red-600 text-white border-red-700",
  2: "bg-amber-100 text-amber-800 border-amber-300",
  3: "bg-slate-100 text-slate-600 border-slate-300",
};

export const OrderImportanceBadge = ({ level, testId, compact = false }) => {
  if (![1, 2, 3].includes(Number(level))) return null;
  const n = Number(level);
  return (
    <span
      className={`inline-flex items-center justify-center rounded border font-bold text-[11px] leading-none ${compact ? "h-5 w-5" : "h-5 px-1.5 gap-1"} ${TONES[n]}`}
      title={`Order importance ${n} — ${IMPORTANCE_LABELS[n]}`}
      data-testid={testId}
    >
      {compact ? n : <>IMP {n}</>}
    </span>
  );
};
